import ajax from '@/utils/ajax';

export const head = '/web';

// 根据电商订单号查询旺店通快递记录
export const reqWdtExpress = (srcTid) => ajax(`${head}/v1/expressDelivery/ec-wdt-express?srcTid=${srcTid}`, '', 'GET');

// 查询电商订单物流详情
export const reqLogisticsDetail = (expressNo) => ajax(`${head}/v1/expressDelivery/ec-logistics-details?expressNo=${expressNo}

`, '', 'GET');
